import _classCallCheck from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../../internal/Action.js";
import { QualifierValue } from "../../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../../internal/qualifier/Qualifier.js";
import { ACTION_TYPE_TO_EFFECT_MODE_MAP, EFFECT_MODE_TO_ACTION_TYPE_MAP } from "../../../internal/internalConstants.js";
/**
 * @description A class that defines a simple effect of the type e_{effectName}
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var SimpleEffectAction = /*#__PURE__*/function (_Action) {
  _inherits(SimpleEffectAction, _Action);

  var _super = _createSuper(SimpleEffectAction);

  function SimpleEffectAction(effectType, level) {
    var _this;

    _classCallCheck(this, SimpleEffectAction);

    _this = _super.call(this);
    _this._actionModel = {};
    _this._actionModel.actionType = EFFECT_MODE_TO_ACTION_TYPE_MAP[effectType] || effectType;

    var qualifierEffect = _this.createEffectQualifier(effectType, level);

    _this.addQualifier(qualifierEffect);

    return _this;
  }

  _createClass(SimpleEffectAction, [{
    key: "createEffectQualifier",
    value: function createEffectQualifier(effectType, level) {
      var qualifierValue;

      if (level) {
        qualifierValue = new QualifierValue([effectType, "".concat(level)]).setDelimiter(':');
      } else {
        qualifierValue = new QualifierValue(effectType);
      }

      return new Qualifier('e', qualifierValue);
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var actionType = actionModel.actionType,
          level = actionModel.level,
          strength = actionModel.strength;
      var effectType = ACTION_TYPE_TO_EFFECT_MODE_MAP[actionType] || actionType; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created
      // @ts-ignore

      var result = new this(effectType, level ? level : strength);
      return result;
    }
  }]);

  return SimpleEffectAction;
}(Action);

export { SimpleEffectAction };